(async () => {
    const { Core } = await importModule('Core');
    // Icons ship as theme assets (icon-<name>.svg, same-origin CDN) — the
    // GitHub raw URL survives only as a fallback for icon names typed into
    // the customizer that we haven't vendored.
    const THEME_ICONS_URL = window.theme?.iconsBaseUrl;
    const ICONS_URL = "https://raw.githubusercontent.com/FortAwesome/Font-Awesome/6.x/svgs/solid/";
    const ICON_PREFIX = 'icon-';
    const CN_ICON = '#icon';

    customElements.define('load-icon', class extends Core {

        async render() {
            if (this.localIcon || await this._loadIcon()) {
                this._displayIcon() 
                this._setIconProps()
                return
            } 
            this._removeContainer();
        }

        async _loadIcon() {
            const urls = [];
            if (THEME_ICONS_URL) urls.push(`${THEME_ICONS_URL}icon-${this.iconName}.svg`);
            urls.push(`${ICONS_URL}/${this.iconName}.svg`);
            for (const url of urls) {
                try {
                    const res = await fetch(url);
                    if (!res.ok) throw new Error(res.status);
                    const svg = await res.text();
                    this.localIcon = svg;
                    return svg;
                } catch (error) {
                    // fall through to the next source
                }
            }
            console.error(`load-icon: no source for "${this.iconName}"`);
            return null;
        }

        _displayIcon() {
            this.innerHTML = this.localIcon;
        }
        
        _setIconProps() {
            const $icon = this.querySelector('svg');
            $icon.classList.add(CN_ICON);
            $icon.style.setProperty('--size', this.getAttribute('size'));
        }

        _removeContainer() {
            this.remove();
        }

        get localIcon() {
            return localStorage.getItem(this.localIconName)
        }

        set localIcon(svg) {
            return localStorage.setItem(this.localIconName, svg)
        }
        
        get iconName() {
            return this.getAttribute('name')
        }

        get localIconName() {
            return `${ICON_PREFIX}${this.iconName}`
        }
    })
})();